import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { provisioningTabs } from './helpers/index';

const ProvisioningTabs = () => <Tabs tabs={provisioningTabs} />;

export default ProvisioningTabs;
